import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MasterDataSeriveService } from 'src/app/Services/master-data-serive.service';

@Injectable({
  providedIn: 'root'
})
export class ReportsApiService {
  constructor(
    private masterService: MasterDataSeriveService,
    private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string
  ) { }

    getSellThroughReportV2(
    companyId: number,
    storeId: string,
    departmentId: number,
    categoryId: number,
    startDate?: string|null,
    endDate?: string|null,
    productionCycleId?: number
  ) {
    const user = this.masterService.getUserDetailsFromStorage();
  
    const params = new HttpParams()
      .set('companyId', companyId.toString())
      .set('storeId', storeId.toString())
      .set('departmentId', departmentId.toString())
      .set('categoryId', categoryId.toString())
      .set('userId', user.userId.toString())
      .set('startDate', startDate ?? 'null')
      .set('endDate', endDate ?? 'null')
      .set('productionCycleId', (productionCycleId ?? 0).toString());
  
    const url = `${this.baseUrl}Reports/SellThroughReport`;
  
    return this.http.get(url, { params });
  }

  getEmployeeReport(
    companyId: number,
    storeId: number,
    departmentId: string,
    categoryId: number,
    startDate: string | any,
    endDate: string | any,
    productionCycleId: number | null,
    employeeIds: number[] = [],
    subCategoryId: number = 0
  ) {
    let user = this.masterService.getUserDetailsFromStorage();

      let params = new HttpParams()
      .set('companyId', companyId.toString())
      .set('storeId', storeId.toString())
      .set('departmentId', departmentId.toString())
      .set('categoryId', categoryId.toString())
      .set('subCategoryId', subCategoryId.toString())
      .set('userId', user.userId.toString())
      .set('startDate', startDate ?? 'null')
      .set('endDate', endDate ?? 'null')
      .set('productionCycleId', (productionCycleId ?? 0).toString());

      if (employeeIds && employeeIds.length) {
        params = params.set('employeeIds', employeeIds.join(','));
      }

      // V2 report table endpoint — returns { items }, matching this component's res.items usage.
     const url = `${this.baseUrl}Reports/EmployeeReportTable`;
      return this.http.get(url, { params });

  }

  getEmployeeSummary(
    companyId: number,
    storeId: number,
    departmentId: string,
    goalValueID: number,
    goalIntervalID: number,
    categoryId: number,
    startDate: string | any,
    endDate: string | any,
    productionCycleId:number|null
  ) {
    let user = this.masterService.getUserDetailsFromStorage();
      const params = new HttpParams()
      .set('companyId', companyId.toString())
      .set('storeId', storeId.toString())
      .set('departmentId', departmentId.toString())
      .set('categoryId', categoryId.toString())
      .set('userId', user.userId.toString())
      .set('startDate', startDate ?? 'null')
      .set('endDate', endDate ?? 'null')
      .set('productionCycleId', (productionCycleId ?? 0).toString());
      
     const url = `${this.baseUrl}Reports/EmployeeReportSummary`;  
      return this.http.get(url, { params });
  }
}
